<template>
  <div>
    <view-component title="Referensi Penugasan PSP" :schema="schema" class="my-2" @edit="onEdit" />
    <base-modal-full ref="modal" generalError title="Update Referensi Penugasan FSP" @save="onSave">
      <formulir-penugasan ref="formulir" :initValue="formulir.init" :masters="masters" :detail="formulir.detail" />
    </base-modal-full>
  </div>
</template>

<script>
import ViewComponent from '../base/View';
import FormulirPenugasan from '../forms/Penugasan';
import { mapActions } from 'vuex';

export default {
  name: 'Biodata',
  components: { ViewComponent, FormulirPenugasan },
  props: {
    index: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBiodataUpdates: {
      type: Array,
      default: () => [],
    },
    kVervalPsp: {
      type: Number,
      default: 1,
    },
    isEditBiodata: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formulir: {},
    };
  },
  computed: {
    tugasEdit() {
      return this.edit.tugas_edit || {};
    },

    rencanas() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'rencana')
        .sort((a, b) => a.prioritas - b.prioritas)
        .map((t, id) => {
          return `${id + 1}. ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    aktifs() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'aktif')
        .map((t) => {
          return `${t.jml_pendampingan || 0} ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    lamas() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'selesai')
        .map((t) => {
          return `${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    schema() {
      return [
        {
          items: [
            {
              label: 'Jenjang dan Jumlah Satuan Pendidikan Penugasan sebagai FSP',
              value: this.$fkata(this.aktifs),
              update: this.tugasEdit['aktif'],
              size: 6,
            },
            {
              label: 'Jenjang satuan pendidikan yang pernah didampingi sebelumnya',
              value: this.$fkata(this.lamas),
              update: this.tugasEdit['selesai'],
              size: 6,
            },
            {
              label: 'Prioritas pendampingan jenjang satuan pendidikan jika terpilih sebagai fasilitator',
              value: this.rencanas.join('<br>'),
              update: this.tugasEdit['rencana'],
              size: 6,
            },
          ],
        },
      ];
    },
  },
  methods: {
    ...mapActions('biodata', ['actions']),

    onEdit() {
      if (!this.isEditBiodata) {
        this.$error('Data tidak bisa diubah karena telah diajukan');
        return;
      }

      if (this.index.tutup) {
        this.$error(this.index.tutup);
        return;
      }

      this.$set(this.formulir, 'init', this.biodata);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();
      let tugases = [];

      for (const kJenjang in values.aktifs) {
        const value = values.aktifs[kJenjang] || {};
        if (+value.is_pilih === 1) {
          tugases.push({
            status_gelombang: 'aktif',
            k_jenjang: kJenjang,
            jml_pendampingan: value.jumlah || 0,
          });
        }
      }

      for (const kJenjang in values.lamas) {
        const value = values.lamas[kJenjang] || {};
        if (+value.is_pilih === 1) {
          tugases.push({
            status_gelombang: 'selesai',
            k_jenjang: kJenjang,
          });
        }
      }

      for (const prioritas in values.rencanas) {
        const value = values.rencanas[prioritas] || {};
        if (value !== null) {
          tugases.push({
            status_gelombang: 'rencana',
            k_jenjang: value,
            prioritas: Number(prioritas) + 1,
          });
        }
      }

      this.actions({ params: { tugases }, update: this.$isObject(this.edit), action: 'save-tugas' })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.$emit('reload');
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>
